import { useNavigate } from 'react-router-dom';
import { ImageLocation } from 'src/utils/URLUtils';
import styles from './EmptyList.module.scss';

interface EmptyListProps {
    image: string;
    description: string;
    buttonUrl: string;
}

const EmptyList = ({ image, description, buttonUrl }: EmptyListProps) => {
    const navigate = useNavigate();

    const handleContinue = () => {
        navigate(buttonUrl);
    }

    return (
        <div className={styles.emptyList}>
            <img src={ImageLocation(image)} alt="No words to learn" />
            <p>{description}</p>
            <button onClick={handleContinue} >Let's go</button>
        </div>
    );
};

export default EmptyList;
